/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiAuthBarberLogout200, PostApiAuthBarberLogout401, PostApiAuthBarberLogoutMutationResponse } from "../entities/PostApiAuthBarberLogout";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiAuthBarberLogout200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiAuthBarberLogout200>

/**
 * @description Unauthorized
 */
export const postApiAuthBarberLogout401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiAuthBarberLogout401>

export const postApiAuthBarberLogoutMutationResponseSchema = z.lazy(() => postApiAuthBarberLogout200Schema) as unknown as z.ZodType<PostApiAuthBarberLogoutMutationResponse>